import React from 'react';
import { ChevronRight } from 'lucide-react';  
import { MainLayout } from './MainLayout';
import { useApp } from './AppContext';

export function BillingData() {
  const { setCurrentScreen } = useApp();

  const menuItems = [
    {
      id: 'financial-data',
      label: 'Financial Data'
    },
    {
      id: 'payroll-document', 
      label: 'Payroll Document'
    }
  ];

  const handleBack = () => {
    setCurrentScreen('my-profile');
  };

  const handleMenuClick = (itemId: string) => {
    setCurrentScreen(itemId as any);
  };

  return (
    <MainLayout showBack onBack={handleBack}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[var(--ucm-text-dark)]">
          Billing Data
        </h1>
      </div>

      <div className="space-y-2">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className="bg-white rounded-xl p-4 shadow-[0_2px_8px_rgba(0,0,0,0.06)] cursor-pointer hover:shadow-[0_4px_16px_rgba(0,0,0,0.08)] transition-shadow"
            onClick={() => handleMenuClick(item.id)}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-[var(--ucm-text-dark)]">
                {item.label}
              </span>
              <ChevronRight size={16} className="text-[var(--ucm-text-light)]" />
            </div>
          </div>
        ))}
      </div>
    </MainLayout>
  );
}